import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (!_ctx.allowChanging)
    ? (_openBlock(), _createBlock(_component_v_chip, {
        key: 0,
        "prepend-icon": _ctx.priority.icon,
        color: _ctx.priority.color
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.priority.name), 1)
        ]),
        _: 1
      }, 8, ["prepend-icon", "color"]))
    : (_openBlock(), _createBlock(_component_v_menu, { key: 1 }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_chip, _mergeProps(props, {
            "prepend-icon": _ctx.priority.icon,
            color: _ctx.priority.color
          }), {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.priority.name), 1)
            ]),
            _: 1
          }, 16, ["prepend-icon", "color"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPriorityConfigs, (priorityOpt) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: priorityOpt.priorityId
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_chip, {
                          "prepend-icon": priorityOpt.icon,
                          color: priorityOpt.color,
                          onClick: ($event: any) => (_ctx.setPriority(priorityOpt.priorityId))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(priorityOpt.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["prepend-icon", "color", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}